import { render, staticRenderFns } from "./PowerBIReport.vue?vue&type=template&id=c59b9f3a&"
import script from "./PowerBIReport.vue?vue&type=script&lang=js&"
export * from "./PowerBIReport.vue?vue&type=script&lang=js&"
import style0 from "./PowerBIReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports